import { UserSignUp } from "@/models/entities/user-signup.interface";
import { ApiService } from "vuelando";

const controller = "signup";

class SignUpService extends ApiService {
  constructor() {
    super(process.env.VUE_APP_API_ENDPOINT);
  }

  SignUp(userSignUp: UserSignUp) {
    return this.post<UserSignUp, void>(`${controller}/signup`, userSignUp);
  }

  ConfirmUser(token: string) {
    return this.post<string, void>(
      `${controller}/confirmUser?token=${token}`,
      ""
    );
  }

  SendConfirmMail(email: string) {
    return this.getAll<string>(`${controller}/sendConfirmMail?email=${email}`);
  }
}

export const signUpService = new SignUpService();
